import { Outlet } from 'react-router-dom';
import { Container } from '@mui/material';

const SignInLayout = () => {
    return (
        <Container
            maxWidth="sm"
            disableGutters={true}
            sx={{
                minHeight: '100vh',
                background: theme => theme.palette.background.default,
            }}
        >
            <Outlet />
        </Container>
    );
}

export default SignInLayout;
